import { useState, useEffect } from 'react';

export const useImage = (imageUrl) => {
  const [validUrl, setValidUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const validateImageUrl = async () => {
      if (!imageUrl) {
        setError(true);
        setValidUrl(null);
        return;
      }

      try {
        await new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve();
          img.onerror = () => reject();
          img.src = imageUrl;
        });
        setValidUrl(imageUrl);
        setError(null);
      } catch {
        setError(true);
        setValidUrl(null);
      }
    };

    validateImageUrl();
  }, [imageUrl]);

  return { url: validUrl, error };
};
